import { render } from "./AchievementsLeaderBoardPage.vue?vue&type=template&id=362daeaa&scoped=true"
import script from "./AchievementsLeaderBoardPage.vue?vue&type=script&lang=js"
export * from "./AchievementsLeaderBoardPage.vue?vue&type=script&lang=js"

import "./AchievementsLeaderBoardPage.vue?vue&type=style&index=0&id=362daeaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362daeaa"]])

export default __exports__